module.exports = __webpack_public_path__ + "static/jan_2-77485b56ab43a39e539b4604f857e18e.mp4";